import { IndexPagePaphosState } from './indexPagePaphos/indexPagePaphos.initialState';

export type IndexPageAction = { type: string };

export const indexPageReducer = (state: IndexPagePaphosState = {} as IndexPagePaphosState, action: IndexPageAction) => {
  switch (action.type) {
    default:
      return state;
  }
};
